"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAnchorLink = exports.StyledTappableCard = exports.classes = void 0;
const Typography_1 = require("@mui/material/Typography");
const styles_1 = require("@mui/material/styles");
const anchor_link_1 = __importDefault(require("../anchor-link"));
const tappable_card_1 = __importStar(require("../tappable-card"));
const PREFIX = "NBACard";
exports.classes = {
    showCta: `${PREFIX}-showCta`
};
exports.StyledTappableCard = (0, styles_1.styled)(tappable_card_1.default)({
    opacity: 0.95,
    [`.${tappable_card_1.tappableCardClasses.title}`]: {
        color: "unset"
    },
    [`.${tappable_card_1.tappableCardClasses.text}`]: {
        color: "unset"
    },
    [`.${Typography_1.typographyClasses.root}`]: {
        color: "unset"
    },
    "&:hover": {
        opacity: 1,
        [`.${tappable_card_1.tappableCardClasses.title}`]: {
            color: "unset"
        },
        [`.${tappable_card_1.tappableCardClasses.text}`]: {
            color: "unset"
        },
        [`.${Typography_1.typographyClasses.root}`]: {
            color: "unset"
        }
    }
});
exports.StyledAnchorLink = (0, styles_1.styled)(anchor_link_1.default)({
    minHeight: "32px",
    minWidth: "32px"
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL25iYS1jYXJkL3N0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLHlEQUE2RDtBQUM3RCxpREFBOEM7QUFDOUMsaUVBQXdDO0FBQ3hDLGtFQUFxRTtBQUVyRSxNQUFNLE1BQU0sR0FBRyxTQUFTLENBQUM7QUFFWixRQUFBLE9BQU8sR0FBRztJQUNyQixPQUFPLEVBQUUsR0FBRyxNQUFNLFVBQVU7Q0FDN0IsQ0FBQztBQUVXLFFBQUEsa0JBQWtCLEdBQUcsSUFBQSxlQUFNLEVBQUMsdUJBQVksQ0FBQyxDQUFDO0lBQ3JELE9BQU8sRUFBRSxJQUFJO0lBQ2IsQ0FBQyxJQUFJLG1DQUFtQixDQUFDLEtBQUssRUFBRSxDQUFDLEVBQUU7UUFDakMsS0FBSyxFQUFFLE9BQU87S0FDZjtJQUNELENBQUMsSUFBSSxtQ0FBbUIsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFO1FBQ2hDLEtBQUssRUFBRSxPQUFPO0tBQ2Y7SUFDRCxDQUFDLElBQUksOEJBQWlCLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtRQUM5QixLQUFLLEVBQUUsT0FBTztLQUNmO0lBQ0QsU0FBUyxFQUFFO1FBQ1QsT0FBTyxFQUFFLENBQUM7UUFDVixDQUFDLElBQUksbUNBQW1CLENBQUMsS0FBSyxFQUFFLENBQUMsRUFBRTtZQUNqQyxLQUFLLEVBQUUsT0FBTztTQUNmO1FBQ0QsQ0FBQyxJQUFJLG1DQUFtQixDQUFDLElBQUksRUFBRSxDQUFDLEVBQUU7WUFDaEMsS0FBSyxFQUFFLE9BQU87U0FDZjtRQUNELENBQUMsSUFBSSw4QkFBaUIsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFO1lBQzlCLEtBQUssRUFBRSxPQUFPO1NBQ2Y7S0FDRjtDQUNGLENBQUMsQ0FBQztBQUVVLFFBQUEsZ0JBQWdCLEdBQUcsSUFBQSxlQUFNLEVBQUMscUJBQVUsQ0FBQyxDQUFDO0lBQ2pELFNBQVMsRUFBRSxNQUFNO0lBQ2pCLFFBQVEsRUFBRSxNQUFNO0NBQ2pCLENBQUMsQ0FBQyJ9